module.exports = __webpack_public_path__ + "img/trustIt.e05789b5.png";